import { publicLongEcho as publicPublicLongEcho } from './metroinspector-v1-long-echo.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const publicLongEcho: MaybeContext<
  BuildRESTFunction<typeof publicPublicLongEcho> & typeof publicPublicLongEcho
> = /*#__PURE__*/ createRESTModule(publicPublicLongEcho);

export {
  LongMessage,
  PublicLongEchoOptions,
} from './metroinspector-v1-long-echo.universal.js';
